import * as React from "react";
import { makeStyles } from "@mui/styles"; // TODO remove this deps asap (from package.json)
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    Grid,
    Link,
    Theme,
    Typography,
} from "@mui/material";
import Layout from "../../../components/customOrgs/senzacni/Layout";
import StarIcon from "@mui/icons-material/StarBorder";
import Nlink from "next/link";
import Image from "next/legacy/image";

const useStyles = makeStyles<Theme>((theme) => ({
    heroContent: {
        padding: theme.spacing(2, 0, 6),
    },
    cardHeader: {
        minHeight: theme.spacing(14),
        alignItems: "flex-start",
        backgroundColor:
            theme.palette.mode === "light"
                ? theme.palette.grey[200]
                : theme.palette.grey[700],
    },
    cardPricing: {
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
        marginBottom: theme.spacing(2),
    },
}));

interface Segment {
    month: string;
    place: string;
    title: string;
    distance: number;
    strava: number;
    photo: string;
    page?: string;
}

const segments: Array<Segment> = [
    {
        title: "Z Čertových kamenů do České Vsi",
        month: "červen",
        place: "Česká Ves",
        distance: 2.4,
        strava: 23217061,
        page: "/ceska-ves",
        photo: "certaky.jpg",
    },
    {
        title: "Nahoru i dolů s cílem na Ramzové",
        month: "červenec",
        place: "Ostružná",
        strava: 24693300,
        distance: 5,
        photo: "ramzova.jpg",
        page: "/ramzova",
    },
    {
        title: "Krásný a těžký výšlap na Šerák",
        month: "srpen",
        place: "Lipová-lázně",
        strava: 25023814,
        distance: 8,
        photo: "serak.jpg",
        page: "/serak",
    },
    {
        title: "Od obecního úřadu v Bělé mírný seběh až do Jeseníku\n",
        month: "září",
        place: "Bělá pod Pradědem",
        strava: 25485327,
        distance: 7,
        photo: "bela.jpg",
        page: "/bela",
    },
    {
        title: "Od Technických služeb až na Bobrovník",
        month: "říjen",
        place: "Jeseník",
        distance: 4.6,
        strava: 24211135,
        photo: "bobrovnik.jpeg",
        page: "/bobrovnik",
    },
    {
        title: "Muzikantská stezka",
        month: "říjen",
        place: "Jeseník",
        distance: 1.4,
        strava: 20928255,
        photo: "muzikantska.jpeg",
        page: "/muzikantska",
    },
];

function Index() {
    const classes = useStyles();

    return (
        <Layout>
            {/* Start hero unit */}
            <Container
                maxWidth="sm"
                component="main"
                className={classes.heroContent}
            >
                {/*<Typography*/}
                {/*    component="h1"*/}
                {/*    variant="h2"*/}
                {/*    align="center"*/}
                {/*    color="text.primary"*/}
                {/*    gutterBottom*/}
                {/*>*/}
                {/*    Je to sen?*/}
                {/*</Typography>*/}
                <Typography
                    variant="h5"
                    align="center"
                    color="text.secondary"
                    component="p"
                >
                    Navazujeme na předchozí ročník a roztáčíme kola druhé sezóny
                    virtuálního běhu v&nbsp;regionu Jeseníku a&nbsp;blízkého
                    okolí – tedy Mikroregionu. Po dohodě se všemi obcemi a
                    městem Jeseník jsme se rozhodli zopakovat jednotlivé trasy,
                    s&nbsp;tím, že začneme v&nbsp;červnu a&nbsp;v&nbsp;říjnovém
                    měsíci si střihneme obě trasy v&nbsp;Jeseníku.
                </Typography>
            </Container>

            <Container maxWidth="md" sx={{ marginY: 5 }}>
                <Typography variant={"h5"} gutterBottom>
                    Začni běh
                </Typography>
                <Typography gutterBottom>
                    Přinášíme Vám možnost v průběhu června až října absolvovat
                    s&nbsp;námi 6 různých měsíčních výzev. To hlavní: jde o
                    pohyb po svých – tedy chůze, běh či jejich kombinace. Kdy
                    začít? Od začátku června máte možnost do toho skočit dle
                    Vašich časových možností! Ano v noci, ráno, během dne i
                    večer. Záleží jen na Vás. Už žádné výmluvy – JDI DO TOHO,
                    ZAČNI BĚHAT. Půjdeš trasu každý den, nebo jen jednou
                    měsíčně? Záleží na tobě. Svůj progres uvidíš průběžně v
                    systému a máš možnost soupeřit. Ano, to je další možnost –
                    máš možnost se na dálku seznámit s dalšími aktivními! Že tě
                    v první výzvě Petr porazil? Druhá výzva bude mít jiný
                    profil, máš šanci…začni v roce 2021 jinak.
                </Typography>
                <Typography gutterBottom>
                    V roce 2020 jsme si stejným systémem vyzkoušeli. Ano,
                    někteří bojovali o vítězství, jiní bojovali o účast, či
                    lepší čas. My naší aktivitou cílíme na všechny skupiny
                    sportovně aktivních. Od začátečníků (a budeme za ně moc
                    rádi) až po nachystané profesionály, kterým se intenzivně
                    mění kalendář závodů. Letos bychom rádi přivedli nové
                    aktivní lidi dohromady. Rád jen chodíš? Můžeš se zúčastnit
                    taky. Běháš jen ve svém okolí? Ukážeme ti v 5 měsících různé
                    místa našeho regionu. Nerad(a) běháš jen do kopce? Letošní
                    ročník je opět o různých profilech tratě.
                </Typography>
                <Typography>
                    Letos bychom rádi přivedli nové aktivní lidi dohromady. Rád
                    jen chodíš? Můžeš se zúčastnit taky. Běháš jen ve svém
                    okolí? Ukážeme ti v 5 měsících různé místa našeho regionu.
                    Nerad(a) běháš jen do kopce? Letošní ročník je opět o
                    různých profilech tratě.
                </Typography>
            </Container>
            {/* End hero unit */}

            <Container maxWidth="md" component="main">
                <Typography
                    variant={"h5"}
                    gutterBottom
                    sx={{ marginBottom: 2 }}
                >
                    Co nás tedy čeká?
                </Typography>
                <Grid container spacing={5}>
                    {segments.map((segment, i) => (
                        <Grid
                            item
                            key={segment.title}
                            xs={12}
                            md={4}
                            alignItems={"stretch"}
                        >
                            <Card>
                                <CardHeader
                                    title={i + 1 + ". segment"}
                                    subheader={segment.title}
                                    titleTypographyProps={{
                                        align: "center",
                                    }}
                                    subheaderTypographyProps={{
                                        align: "center",
                                    }}
                                    action={
                                        segment.title === "Pro" ? (
                                            <StarIcon />
                                        ) : null
                                    }
                                    className={classes.cardHeader}
                                />
                                <Box
                                    sx={{
                                        position: "relative",
                                        height: "300px",
                                    }}
                                >
                                    <Image
                                        src={
                                            "/senzacni/photos/" + segment.photo
                                        }
                                        alt={segment.title}
                                        title={segment.title}
                                        layout={"fill"}
                                        objectFit={"cover"}
                                    />
                                </Box>
                                <CardContent>
                                    <ul>
                                        <li>{segment.month} 2021</li>
                                        <li>Délka: {segment.distance}km</li>
                                        <li>
                                            <Link
                                                target={"_blank"}
                                                href={`https://www.strava.com/segments/${segment.strava}`}
                                            >
                                                Strava segment
                                            </Link>
                                        </li>
                                    </ul>
                                </CardContent>
                                {segment.page && (
                                    <CardActions>
                                        <Nlink href={segment.page} passHref>
                                            <Button
                                                fullWidth
                                                variant={"contained"}
                                            >
                                                Podrobnosti
                                            </Button>
                                        </Nlink>
                                    </CardActions>
                                )}
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Layout>
    );
}

export default Index;
